<template>
  <div>
    <b-card>
      <b-alert show>
        <div class="alert-body text-center font-medium-5">
          Sayfa hazırlanıyor.
        </div>
      </b-alert>
      <b-row>
        <b-col>Disk Kullanımı</b-col>
        <b-col>Kullanıcı Sayısı</b-col>
        <b-col>Ürün Adet</b-col>
        <b-col>Aylık Ziyaret Ortalaması</b-col>
        <b-col>Ürün Kategorisi</b-col>
        <b-col>QR Kod Sayısı</b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BAlert,
} from 'bootstrap-vue'

export default {
  name: 'DrStatistics',
  components: {
    BCard,
    BRow,
    BCol,
    BAlert,
  },
}
</script>
